module.exports = __webpack_public_path__ + "static/media/jan.f8954be4.jpg";